<template>
  <b-row>
    <b-col>
      <b-table fixed borderless outlined :items="tableItems" :fields="fields">
        <template
          v-for="(field, index) in fields"
          #[`cell(${field.key})`]="data"
        >
          <Input
            v-if="field.type === 'input' && tableItems[data.index].isEdit"
            :key="index"
            :value="tableItems[data.index][field.key]"
            :error="$v.inEditing[field.key].$error"
            @input="(value) => inputHandler(value, data.index, field.key)"
          />
          <Input
            v-else-if="
              field.type === 'inputNumber' && tableItems[data.index].isEdit
            "
            :key="index"
            :value="tableItems[data.index][field.key]"
            :error="$v.inEditing[field.key].$error"
            :mask="['#########']"
            @input="(value) => inputHandler(value, data.index, field.key)"
          />
          <CheckboxSwitch
            :id="field.type + index"
            v-else-if="
              field.type === 'checkboxSwitch' && tableItems[data.index].isEdit
            "
            :key="index"
            :value="tableItems[data.index][field.key]"
            @input="(value) => inputHandler(value, data.index, field.key)"
          />
          <CheckboxSwitch
            :id="field.type + index"
            v-else-if="
              field.type === 'checkboxSwitch' && !tableItems[data.index].isEdit
            "
            :key="index"
            :value="tableItems[data.index][field.key]"
            disabled
          />
          <div
            v-else-if="field.type === 'edit'"
            :key="index"
            class="text-center"
          >
            <span v-if="!tableItems[data.index].isEdit" role="button"
              ><Edit
                class="icon-2x"
                title="Editar"
                @click="editRowHandler(data)"
            /></span>
            <span v-else role="button">
              <b-row no-gutters>
                <b-col>
                  <CheckBold
                    class="icon-2x"
                    title="Salvar"
                    @click="editRowHandler(data)"
                  />
                </b-col>
                <b-col v-if="!tableItems[data.index].id">
                  <Close
                    class="icon-2x"
                    title="Cancelar"
                    @click="deleteRowHandler(data)"
                  />
                </b-col>
              </b-row>
            </span>
          </div>
          <span :key="index" v-else>{{ data.value }}</span>
        </template>
      </b-table>
      <Button
        type="success"
        class="float-right m-0"
        @click="addRowHandler"
        :disabled="inEditing && inEditing.isEdit"
      >
        {{ newRowButtonTitle }}
      </Button>
    </b-col>
  </b-row>
</template>

<script>
import { CheckboxSwitch, Input, Button } from '@/components/Form';
import Edit from 'vue-material-design-icons/Pencil';
import Close from 'vue-material-design-icons/Close';
import CheckBold from 'vue-material-design-icons/CheckBold';
import { required, maxLength } from '@/reusable';

export default {
  name: 'EditableTable',
  components: { Input, CheckboxSwitch, Edit, CheckBold, Close, Button },
  props: {
    value: Array,
    fields: Array,
    newRowButtonTitle: {
      type: String,
      default: 'Novo',
    },
  },
  validations() {
    return {
      inEditing: {
        ...this.tableValidations,
      },
    };
  },
  data() {
    return {
      tableItems: this.value.map((item) => ({ ...item, isEdit: false })),
      tableValidations: this.makeValidation(),
      inEditing: null,
    };
  },
  methods: {
    editRowHandler(data) {
      const { isEdit } = this.tableItems[data.index];
      const hasMoreThanAnEditing = this.tableItems.find((e) => e.isEdit);

      if (!isEdit && hasMoreThanAnEditing) return;

      if (isEdit) {
        this.$v.inEditing.$touch();
        if (this.$v.inEditing?.$error) return;
      }

      this.tableItems[data.index].isEdit = !isEdit;
      this.inEditing = this.tableItems[data.index];
    },
    deleteRowHandler(data) {
      this.tableItems.splice(data.index, 1);
      this.inEditing = null;
    },
    inputHandler(value, index, key) {
      this.tableItems[index][key] = value;
      this.$set(this.tableItems, index, this.tableItems[index]);
      this.$emit('input', this.tableItems);
    },
    makeValidation() {
      return this.fields.reduce((a, c) => {
        const validations = {
          ...a,
          [c.key]: {},
        };
        if (c.required) {
          Object.assign(validations[c.key], { required });
        }
        if (c.maxLength) {
          Object.assign(validations[c.key], { maxLength: maxLength(6) });
        }

        return validations;
      }, {});
    },
    addRowHandler() {
      const newRow = this.fields.reduce((a, c) => {
        if (c.type === 'checkboxSwitch') {
          return { ...a, [c.key]: false };
        }

        return { ...a, [c.key]: null };
      }, {});

      newRow.isEdit = true;

      this.inEditing = newRow;
      this.tableItems.unshift(newRow);
      this.$emit('input', this.tableItems);
    },
  },
};
</script>

<style scoped>
.material-design-icon.icon-2x {
  height: 1.3em;
  width: 1.3em;
}

.material-design-icon.icon-2x > .material-design-icon__svg {
  height: 1.3em;
  width: 1.3em;
}
</style>
